import {environment} from '@environments/environment';
import {ECookieType, ICookie} from '../models/cookie-consent.model';

export const provider = {
  provider: 'GEN',
  providerLink: '/privacy-policy',
  days: 'CookieConsent.CookieRuntime.TwoDays',
};

export const genCookies: ICookie[] = [
  {
    name: environment.cookie.cookieConsent,
    provider: provider.provider,
    providerLink: provider.providerLink,
    runtime: provider.days,
    purpose: 'CookieConsent.CookiePurpose.GEN.Consent',
    type: ECookieType.StrictlyNecessary,
  },
];
